import PropTypes from 'prop-types';

import BrButton from '@components/BrButton';

export default function BrBottomNav(props) {
  const {
    showContinue,
    showBack,
    disableContinue,
    disableBack,
    customButtons: customComponents,
    onContinueClick,
    onBackClick,
    onCancelClick,
    workflowSteps,
    activeStepIndex,
  } = props;
  return (
    <div className="workflow-bottom-nav-container">
      <BrButton
        className="workflow-bottom-nav-button workflow-bottom-gray-button"
        title="Cancel"
        onClick={(e) => onCancelClick(e, { workflowSteps, activeStepIndex })}
      />
      <div className="workflow-bottom-nav-buttons-right">
        {showBack && (
          <BrButton
            title="Previous"
            className="workflow-bottom-nav-button workflow-bottom-gray-button"
            isDisabled={disableBack}
            onClick={(e) => onBackClick(e, { workflowSteps, activeStepIndex })}
          />
        )}
        {showContinue && (
          <BrButton
            title="Next"
            className="workflow-bottom-nav-button workflow-bottom-blue-button"
            isDisabled={disableContinue}
            onClick={(e) => onContinueClick(e, { workflowSteps, activeStepIndex })}
          />
        )}
        {customComponents && customComponents.map((comp) => comp)}
      </div>
    </div>
  );
}

BrBottomNav.propTypes = {
  showContinue: PropTypes.bool.isRequired,
  showBack: PropTypes.bool.isRequired,
  disableContinue: PropTypes.bool.isRequired,
  disableBack: PropTypes.bool.isRequired,
  customButtons: PropTypes.arrayOf(PropTypes.object),
  onContinueClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  workflowSteps: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeStepIndex: PropTypes.number.isRequired,
};
